import { Box } from '@mui/material';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import TabsPanel from '../../components/TabsPanel';
import { dashboardAccountTabs } from '../../constants/tabRoutes';

const DashboardAccountView = () => {
  const location = useLocation();
  const showUserOnboardingDetails = localStorage.getItem('showUserOnboardingDetails') === 'true';

  if (!showUserOnboardingDetails) {
    if (!location.pathname.endsWith('/summary')) {
      return <Navigate to="/dashboard/summary" replace />;
    }

    return <Outlet />;
  }

  return (
    <>
      <Box display="flex" width="100%">
        <TabsPanel tabsList={dashboardAccountTabs} locationSlicePosition={2} />
      </Box>
    </>
  );
};

export default DashboardAccountView;
